/**
 * HelpSearch.ts
 */
export class HelpSearch {
    constructor() {
        this.scrollIndex = 0;
        this.addFormEventListeners();
        this.init();
    }
    addFormEventListeners() {
        const searchForm = document.getElementById("searchForm");
        searchForm.addEventListener("submit", this.doSearch.bind(this));
        const searchInput = document.getElementById("searchInput");
        searchInput.addEventListener("keydown", this.resetSearch.bind(this));
        const back = (document.getElementById("back"));
        back.addEventListener("click", this.back.bind(this));
        const forward = (document.getElementById("fwd"));
        forward.addEventListener("click", this.forward.bind(this));
    }
    back(e) {
        e.preventDefault();
        this.jumpTo(--this.scrollIndex);
    }
    forward(e) {
        e.preventDefault();
        this.jumpTo(++this.scrollIndex);
    }
    doSearch(e) {
        e.preventDefault();
        const searchValue = document.getElementById("searchInput")["value"];
        const content = document.getElementById("content");
        const resultsfound = document.getElementById("resultsfound");
        // Clear previous search highlighting by unrwapping span children
        const spansToUnwrap = content.querySelectorAll(".highlight,.super-highlight");
        for (const span of spansToUnwrap) {
            this.unwrapTextFromSpan(span);
        }
        // Not searching
        if (searchValue == "") {
            this.resetSearch();
            resultsfound.innerHTML = "";
            return;
        }
        const regexp = new RegExp("(" + searchValue + ")", "gi");
        const matchFound = this.addClassnameToText(content, regexp, [
            "highlight",
        ]);
        if (!matchFound) {
            // no matches? :'(
            resultsfound.innerHTML = "0/0";
            document.getElementById("content").scrollTo(0, 0);
            return;
        }
        document.getElementById("fwd").style.display = "inline-block";
        document.getElementById("back").style.display = "inline-block";
        document.getElementById("searchNow").style.display = "none";
        this.jumpTo((this.scrollIndex = 0));
        return;
    }
    /**
     * Searches through the HTML for text then applies wrapMatchingPartsInSpan
     * @param rootElement - The entire HTML you wish to search through
     * @param search - Regular Expression you wish to match against
     * @param classList - Array of class names to be added when the regular expression matches
     * @return `true` if a match is found
     */
    addClassnameToText(rootElement, search, classList) {
        const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT);
        const nodesToWrap = [];
        while (walker.nextNode()) {
            const node = walker.currentNode;
            // always start searching from the beginning
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test
            search.lastIndex = 0;
            if (search.test(node.nodeValue)) {
                nodesToWrap.push(node);
            }
        }
        // Can't modify the tree while walking
        for (const node of nodesToWrap) {
            this.wrapMatchingPartsInSpan(node, search, classList);
        }
        return nodesToWrap.length > 0;
    }
    /**
     * Wraps search text in a span and applies the classes to that span
     * @param node - The current HTML element that will be broken up to contain spans
     * @param search - Regular Expression you wish to match against
     * @param classList - Array of class names to be added when the regular expression matches
     */
    wrapMatchingPartsInSpan(node, search, classList) {
        const parts = node.nodeValue.split(search);
        if (parts.length > 1) {
            const fragment = document.createDocumentFragment();
            parts.forEach((part, index) => {
                if (index % 2 === 1) {
                    // Odd indices are the matched search strings
                    const span = document.createElement("span");
                    span.classList.add(...classList);
                    // TODO: consider being able to remove classes at the same time
                    // classList.forEach(c => { span.classList.toggle(c)});
                    span.textContent = part;
                    fragment.appendChild(span);
                }
                else {
                    fragment.appendChild(document.createTextNode(part));
                }
            });
            node.parentNode.replaceChild(fragment, node);
        }
    }
    /**
     * Merges an element's contents back into its parent at the same position
     * @param span - highlighted text
     */
    unwrapTextFromSpan(span) {
        const parent = span.parentNode;
        const fragment = document.createDocumentFragment();
        while (span.firstChild) {
            fragment.appendChild(span.firstChild);
        }
        parent.replaceChild(fragment, span);
    }
    jumpTo(index = this.scrollIndex) {
        const superHighlightClass = "super-highlight";
        // Unfocus previous search result
        const previousMatches = document.getElementsByClassName(superHighlightClass);
        for (const element of previousMatches) {
            element.classList.remove(superHighlightClass);
        }
        const matches = document.querySelectorAll(".highlight");
        // clamp index to a valid item
        index = ((index % matches.length) + matches.length) % matches.length;
        index = isNaN(index) ? 0 : index;
        this.scrollIndex = index;
        const currentMatch = matches[index];
        // Focus current search result
        currentMatch.classList.add(superHighlightClass);
        currentMatch.scrollIntoView({
            block: "center",
            inline: "nearest",
            behavior: "smooth",
        });
        // Add results found prompt
        const resultsfound = document.getElementById("resultsfound");
        resultsfound.innerHTML = index + 1 + "/" + matches.length;
    }
    resetSearch() {
        document.getElementById("fwd").style.display = "none";
        document.getElementById("back").style.display = "none";
        document.getElementById("searchNow").style.display = "inline-block";
    }
    init() {
        this.searchInput = document.getElementById("searchInput");
        this.searchInput.addEventListener("input", this.handleInput.bind(this));
    }
    handleInput(evnt) {
        if (!this.searchInput["value"] || this.searchInput["value"] == "") {
            this.doSearch(evnt);
        }
    }
}
//# sourceMappingURL=HelpSearch.js.map